<template>
  <div class="clientOverview">
    <div class="pageContent">
      <spinner v-if="loading" />
      <div v-if="!loading">
        <div class="row">
          <div class="col-sm-3">
            <client-logo :path="client.logo"/>
          </div>
          <div class="col-sm-7">
            <heading type="h1">{{ client.name }}</heading>
            <router-link v-if="isAdmin" :to="{ path: `/client/${$route.params.id}/edit` }" class="btn btn-xs btn-warning"><i class="fa fa-edit"></i> Edit</router-link>
          </div>
        </div>
        <hr/>
        <div class="row">
          <div class="col-md-9 col-lg-9">
            <div class="clientOverview__section">
              <heading type="h2">Latest Campaigns</heading>
              <campaign-table :tableData="latestCampaigns" :launchActionModal="onLaunchModal" />
              <button-cta title="confirm" data-modalType="createCampaign" :onClick="onLaunchModal">
                Create Campaign
              </button-cta>
              <br />
              <br />
              <div>
                <router-link :to="{ path: `/client/${$route.params.id}/campaigns` }" class="btn btn-warning">View all campaigns</router-link>
              </div>
            </div>
            <hr />
            <div class="clientOverview__section">
              <heading type="h2">Invoicing</heading>

              <invoice-table :tableData="client.invoices" />

              <router-link :to="{ path: `/client/${$route.params.id}/invoices` }" class="btn btn-warning">View all invoices</router-link>
            </div>
          </div>
          <div class="col-md-3 col-lg-3">
            <heading type="h2">Users</heading>
            <ul>
              <li v-for="(user, index) in clientUsers" :key="index">{{ user }}</li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <portal to="globalModal">
      <modal-create-campaign :show="showModal.createCampaign" @close="toggleModal('createCampaign')" />
      <modal-edit-campaign :show="showModal.editCampaign" :currentCampaign="editCampaign" :campaignId="modalId" :field="modalField" :callback="this.reloadClientData" @close="toggleModal('editCampaign')" />
      <modal-clone-campaign :show="showModal.cloneCampaign" :campaignId="modalId" :clientId="client ? client.hash_id : null" :callback="this.reloadClientData" @close="toggleModal('cloneCampaign')" />
      <modal-delete-campaign :show="showModal.deleteCampaign" :campaignId="modalId" :clientId="client ? client.hash_id : null" :callback="this.reloadClientData" @close="toggleModal('deleteCampaign')" />
    </portal>

  </div>
</template>

<script>
import Heading from '@/components/Heading/heading'
import ClientLogo from '@/components/ClientLogo/client-logo'
import Spinner from '@/components/SpinnerIcon/spinner'
import SlotTable from '@/components/Table/table'
import ButtonCta from '@/components/Button/button'
import ModalCreateCampaign from '@/components/Modal/campaigns/modal-create-campaign'
import CampaignTable from '@/components/CampaignTable/campaign-table'
import InvoiceTable from '@/components/InvoiceTable/invoice-table'
import {clientMixin} from '@/mixins/clientMixin'
import {notificationMixin} from '@/mixins/notificationMixin'
import {invoiceMixin} from '@/mixins/invoiceMixin'
import {modalMixin} from '@/mixins/modalMixin'
import ModalEditCampaign from '@/components/Modal/campaigns/modal-edit-campaign'
import ModalCloneCampaign from '@/components/Modal/campaigns/modal-clone-campaign'
import ModalDeleteCampaign from '@/components/Modal/campaigns/modal-delete-campaign'

import {map, assoc, find, propEq} from 'ramda'

export default {
  name: 'Clients',
  mixins: [clientMixin, notificationMixin, invoiceMixin, modalMixin],
  props: {
    isAdmin: Boolean
  },
  components: {
    InvoiceTable,
    CampaignTable,
    Heading,
    ClientLogo,
    Spinner,
    SlotTable,
    ButtonCta,
    ModalCreateCampaign,
    ModalEditCampaign,
    ModalCloneCampaign,
    ModalDeleteCampaign
  },
  created () {
    this.startLoading()
    this.getClientOverview(this.clientId).then(() => {
      this.finishLoading()
    }, error => {
      this.addNotification('danger', error)
    })
  },
  beforeRouteLeave (to, from, next) {
    // need to reset client when we leave so data doesn't persist when going to another client
    this.resetClient()
    next()
  },
  data: () => ({
    currency: 'pounds', // TO DO: remove this when comes from API
    table: {
      columns: {
        client: 'Client',
        period_start: 'Date',
        amount: 'Amount',
        invoiceActions: 'invoiceActions'
      }
    },
    campaign: {
      columns: {
        name: 'Name',
        date_created: 'Date Created',
        campaign_job_number: 'Campaign Job Number',
        is_archived: 'Status'

      }
    }
  }),
  computed: {
    clientUsers () {
      return this.client.user_names.split(',')
    },
    latestCampaigns () {
      return this.client.latest_campaigns
    },
    formattedInvoices () {
      // add clientActions key/value to data
      return map(item => assoc('invoiceActions', true, item), this.client.invoices)
    },
    editCampaign () {
      const campaign = find(propEq('hash_id', this.modalId), this.client ? this.latestCampaigns : [])
      return campaign
    }
  },
  mounted () {},
  methods: {
    reloadClientData () {
      this.startLoading()
      this.getClientOverview(this.clientId).then(() => {
        this.finishLoading()
      }, error => {
        this.finishLoading()
        this.addNotification('danger', error)
      })
    }
  }
}
</script>

<style lang="scss">
  .clientOverview {
    &__section {
      margin-bottom: 30px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/client/client-overview.vue